import { render, staticRenderFns } from "./BlogManagerCommentsMenuItems.vue?vue&type=template&id=08fbcd0a&scoped=true"
import script from "./BlogManagerCommentsMenuItems.vue?vue&type=script&lang=js"
export * from "./BlogManagerCommentsMenuItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fbcd0a",
  null
  
)

export default component.exports